import React, { useState } from "react";

import { Form, Formik } from "formik";
import { Link } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";
import { useDispatch, useSelector } from "react-redux";
import { isValidPhoneNumber } from "react-phone-number-input";

import { Stack } from "@mui/system";
import { Box, Button, FormHelperText, Grid } from "@mui/material";

import { Loader } from "../common/loader";
import CallUsNow from "../common/CallUsNow";
import CustomTextField from "../common/CustomTextField";
import help_center from "../../assets/icons/help_center.svg";
import { DEFAULT_URL, GOOGLE_API_KEY } from "../helpers/constants";
import CustomPhoneNumberInput from "../common/CustomPhoneNumberInput";
import { getShortNameAddressFromGoogleAutoComplete } from "../helpers/utils";
import { agentsAdminAction } from "../../redux/slices/brokers/agentAdminSlice";
import CustomizedCheckbox from "../common/customDesignedComponents/customCheckbox";
import { propertyRiskFormValidations } from "../PropertyRiskManagement/PropertyRiskManagementForm";

const ContactUsForm = () => {
  const dispatch = useDispatch();

  const { agentRepLoader } = useSelector((state) => state?.agentsAdmin);
  const validationSchema = propertyRiskFormValidations("address", {
    name: true,
  });

  const [checked, setChecked] = useState(false);
  const [checkTerms, setCheckTerms] = useState(false);

  const onCheckedTerms = (e) => {
    setCheckTerms(e.target.checked);
  };

  const onCheckedAcknowledge = (e) => {
    setChecked(e.target.checked);
  };
  const onSubmit = (values) => {
    if (checked && checkTerms) {
      dispatch(
        agentsAdminAction.getUserContactDetails({
          url: `attorney-contact`,
          data: values,
        })
      );
    }
  };
  return (
    <>
      <Box className="contact-form">
        <Formik
          enableReinitialize
          validateOnChange
          validationSchema={validationSchema}
          initialValues={{
            name: "",
            email: "",
            phone: "",
            address: "",
          }}
          onSubmit={(values, validation) => {
            if (!isValidPhoneNumber(values?.phone)) {
              return;
            }
            onSubmit(values);
          }}
        >
          {({ values, setFieldValue, touched, errors, isSubmitting }) => {
            return (
              <>
                <Form>
                  <Grid container spacing={1.25}>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="p-top-down"
                    >
                      <CustomTextField
                        placeholder="Your Name"
                        name="name"
                        validation={{
                          values,
                          setFieldValue,
                          touched,
                          errors,
                        }}
                        otherProps={{
                          onChange: (event) => {
                            setFieldValue("name", event.target.value);
                          },
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="p-top-down"
                    >
                      <CustomTextField
                        name="email"
                        placeholder="Your Email"
                        type="email"
                        validation={{
                          values,
                          setFieldValue,
                          touched,
                          errors,
                        }}
                        otherProps={{
                          onChange: (event) => {
                            setFieldValue("email", event.target.value);
                          },
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="p-top-down"
                    >
                      <CustomPhoneNumberInput
                        name="phone"
                        values={values}
                        touched={touched}
                        setFieldValue={setFieldValue}
                        errors={errors}
                        otherProps={{
                          onChange: (event) => {
                            setFieldValue("phone", event);
                            if (!event) {
                              setFieldValue("phone", "");
                            }
                          },
                        }}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="p-top-down"
                    >
                      <Autocomplete
                        className={`googleAutoComplete mw-100 ${
                          touched.address && Boolean(errors.address)
                            ? "error_border"
                            : ""
                        }`}
                        name="property"
                        //  value={values?.address}
                        apiKey={GOOGLE_API_KEY}
                        // onChange={(e) => {
                        //   setFieldValue("address", e.target.value);
                        // }}
                        onPlaceSelected={(address) => {
                          setFieldValue(
                            "address",
                            getShortNameAddressFromGoogleAutoComplete(
                              address,
                              "street_number"
                            ) +
                              (getShortNameAddressFromGoogleAutoComplete(
                                address,
                                "street_number"
                              )
                                ? " "
                                : "") +
                              getShortNameAddressFromGoogleAutoComplete(
                                address,
                                "route"
                              )
                          );
                        }}
                        onBlur={(event) => {
                          console.log("onChange==>", event.target.value);

                          setFieldValue("address", event.target.value);
                        }}
                        onKeyDown={(event) =>
                          event.key === "Enter" ? event.preventDefault() : null
                        }
                        placeholder="Enter your property address"
                        options={{
                          types: ["address"],
                          componentRestrictions: { country: "us" },
                        }}
                      />
                      {touched.address && Boolean(errors.address) && (
                        <FormHelperText
                          className="m-0"
                          sx={{
                            color: "#d32f2f !important",
                            maxWidth: "none !important",
                            fontSize: "12px !important",
                          }}
                        >
                          {touched.address && errors.address}
                        </FormHelperText>
                      )}
                    </Grid>
                  </Grid>
                  <Button
                    type="submit"
                    className={`contact_button success_popup_btn mt-4 button_width
                                }`}
                    variant="contained"
                  >
                    Please contact me about the program
                  </Button>

                  <Stack
                    py={1}
                    direction={{
                      md: "column",
                      // sm: "column-reverse",
                      // xs: "column-reverse",
                    }}
                    spacing={1}
                    justifyContent={{
                      // md: `${is_PRM ? "center" : "space-between"}`,
                      sm: "start",
                      // xs: "center",
                    }}
                    alignItems={{
                      md: "start",
                      // sm: "center",
                      // xs: "center",
                    }}
                    color={"black"}
                  >
                    <div className="mt-2">
                      <Stack
                        direction={"row"}
                        spacing={1}
                        justifyContent={"flex-start"}
                        alignItems={"start"}
                        color={"black"}
                      >
                        <span className="py-1">
                          <CustomizedCheckbox onChecked={onCheckedTerms} />
                        </span>
                        <span className="pt-1 text-start">
                          I agree to the{" "}
                          <a
                            href={`${DEFAULT_URL}api/service_agreement_2023.pdf`}
                            target={"_blank"}
                            rel="noreferrer"
                          >
                            Terms and Conditions
                          </a>
                        </span>
                      </Stack>
                      <Stack
                        direction={"row"}
                        spacing={1}
                        justifyContent={"flex-start"}
                        alignItems={"start"}
                        color={"black"}
                      >
                        <span className="py-1">
                          <CustomizedCheckbox
                            onChecked={onCheckedAcknowledge}
                          />
                        </span>
                        <span className="pt-1 text-start">
                          I acknowledge that a sales representative can call me.
                        </span>
                      </Stack>
                      {isSubmitting
                        ? (!checkTerms || !checked) && (
                            <span className="py-3 fw-500 terms_error">
                              You must agree to the terms and conditions to
                              proceed.
                            </span>
                          )
                        : null}
                    </div>
                  </Stack>
                </Form>
              </>
            );
          }}
        </Formik>
      </Box>
      <hr />
      <Stack direction={"row"} justifyContent="center" padding={2}>
        <img src={help_center} alt="help_center" className="me-1" />
        <span className="me-1">Having trouble?</span>
        <CallUsNow
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          renderText={
            <Link className="text-blue text-decoration-none" to="">
              Contact support
            </Link>
          }
        />{" "}
      </Stack>
      <Loader open={agentRepLoader} />
    </>
  );
};

export default ContactUsForm;
